<script setup lang="ts">
import AppBar from '@/components/app-bar.vue'
import ContactOverlay from '@/components/contact-overlay.vue'
import LoadingOverlay from '@/components/common/overlays/loading-overlay.vue'
import ErrorOverlay   from '@/components/common/overlays/error-overlay.vue'
import WarningOverlay   from '@/components/common/overlays/warning-overlay.vue'
import NoQrCodeOverlay from '@/components/common/overlays/no-qrcode-overlay.vue'
import InvalidCardOverlay from '@/components/common/overlays/invalid-card-overlay.vue';
import CookieBanner from "@/components/cookie-banner.vue";
</script>

<template>
  <v-app>
    <app-bar />
    <v-main>
      <loading-overlay />
      <error-overlay />
      <warning-overlay />
      <contact-overlay />
      <no-qr-code-overlay />
      <invalid-card-overlay />
      <router-view />
      <cookie-banner />
    </v-main>
  </v-app>
</template>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}
.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}
.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
